import { call, put, takeLatest } from "redux-saga/effects";
import { sendOtpApi } from "../Context/sendOtpApi";
import { onPostSendOtp, onPostSendOtpError, onPostSendOtpSuccess } from "../Store/Slices/sendOtpSlice";

function* PostSendOtp({ payload }) {
  try {
    const postSendOtpResponse = yield call(sendOtpApi, payload);
    if (postSendOtpResponse.responseCode === "200") {
      yield put(
        onPostSendOtpSuccess({
          postData: postSendOtpResponse.response,
          message: postSendOtpResponse.responseMessage,
          status_code: postSendOtpResponse.responseCode,
        })
      );
    } else {
      yield put(
        onPostSendOtpError({
          data: postSendOtpResponse.response,
          message: postSendOtpResponse.responseMessage,
          status_code: postSendOtpResponse.responseCode,
        })
      );
    }
  } catch (error) {
    const message =
      error.response.data.responseMessage || "Something went wrong";
    yield put(onPostSendOtpError({ data: [], message, status_code: 400 }));
  }
}

export default function* sendOtpSaga() {
  yield takeLatest(onPostSendOtp.type, PostSendOtp);
}
